export default {
  PRE_PRIMARY: {
    PE: "体能与健康",
    LANGUAGE: "语文",
    MATHS: "早期数学",
    SCIENCE: "科学与科技",
    SOCIETY: "个人与群体",
    ARTS: "艺术",
  },
  PRIMARY: {
    CHINESE: "中国语文教育",
    ENGLISH: "英国语文教育",
    MATHS: "数学教育",
    SOCIETY: "小学常识科：个人、社会及人文教育",
    SCIENCE: "小学常识科：科学教育",
    TECHNOLOGY: "小学常识科：科技教育",
    ARTS: "艺术教育",
    PE: "体育",
    CIVIC: "德育及公民教育",
    READING: "从阅读中学习",
  },
  SECONDARY: {
    CHINESE: "中国语文教育",
    ENGLISH: "英国语文教育",
    MATHS: "数学教育",
    BIOLOGY: "科学教育：生物",
    CHEMISTRY: "科学教育：化学",
    PHYSICS: "科学教育：物理",
    IS: "科学教育：综合科学",
    CS: "科学教育：组合科学",
    TECHNOLOGY: "科技教育",
    BUSINESS: "科技教育：企业、会计与财务概论",
    CHINESE_HISTORY: "个人、社会及人文教育：中国历史",
    ECONOMICS: "个人、社会及人文教育：经济",
    RELIGION: "个人、社会及人文教育：宗教教育 /伦理与宗教",
    GEOGRAPHY: "个人、社会及人文教育：地理",
    HISTORY: "个人、社会及人文教育：历史与文化 / 历史",
    SOCIETY: "个人、社会及人文教育：生活与社会",
    HUMANITIES: "个人、社会及人文教育：综合人文",
    TOURISM: "个人、社会及人文教育：旅游与旅游业",
    MUSIC: "艺术教育：音乐",
    ARTS: "艺术教育：视觉艺术",
    PE: "体育",
    LIBERAL: "通识教育科",
    READING: "从阅读中学习",
    OTHERS: "其他学习经历",
    APPLIED: "应用学习",
  },
  TERTIARY: {},
  SPECIAL: {
    BASIC: {
      CHINESE: "(BEC) 中国语文教育",
      ENGLISH: "(BEC) 英国语文教育",
      MATHS: "(BEC) 数学教育",
      SOCIETY: "(BEC) 小学常识科：个人、社会及人文教育",
      SCIENCE: "(BEC) 小学常识科：科学教育",
      TECHNOLOGY: "(BEC) 小学常识科：科技教育",
      ARTS: "(BEC) 艺术教育",
      PE: "(BEC) 体育",
      CIVIC: "(BEC) 德育及公民教育",
      READING: "(BEC) 从阅读中学习",
    },
    SENIOR: {
      CHINESE: "(SSC) 中国语文教育",
      ENGLISH: "(SSC) 英国语文教育",
      MATHS: "(SSC) 数学教育",
      BIOLOGY: "(SSC) 科学教育：生物",
      CHEMISTRY: "(SSC) 科学教育：化学",
      PHYSICS: "(SSC) 科学教育：物理",
      IS: "(SSC) 科学教育：综合科学",
      CS: "(SSC) 科学教育：组合科学",
      TECHNOLOGY: "(SSC) 科技教育",
      BUSINESS: "(SSC) 科技教育：企业、会计与财务概论",
      CHINESE_HISTORY: "(SSC) 个人、社会及人文教育：中国历史",
      ECONOMICS: "(SSC) 个人、社会及人文教育：经济",
      RELIGION: "(SSC) 个人、社会及人文教育：宗教教育 /伦理与宗教",
      GEOGRAPHY: "(SSC) 个人、社会及人文教育：地理",
      HISTORY: "(SSC) 个人、社会及人文教育：历史与文化 / 历史",
      SOCIETY: "(SSC) 个人、社会及人文教育：生活与社会",
      HUMANITIES: "(SSC) 个人、社会及人文教育：综合人文",
      TOURISM: "(SSC) 个人、社会及人文教育：旅游与旅游业",
      MUSIC: "(SSC) 艺术教育：音乐",
      ARTS: "(SSC) 艺术教育：视觉艺术",
      PE: "(SSC) 体育",
      LIBERAL: "(SSC) 通识教育科",
      READING: "(SSC) 从阅读中学习",
      OTHERS: "(SSC) 其他学习经历",
      APPLIED: "(SSC) 应用学习",
    },
    BASIC_ID: {
      CHINESE: "(ID: BEC) 中国语文",
      MATHS: "(ID: BEC) 数学",
      GENERAL: "(ID: BEC) 常识",
      TECHNOLOGY: "(ID: BEC) 科技教育",
      APPLIED: "(ID: BEC) 应用学习调适课程",
    },
    SENIOR_ID: {
      CHINESE: "(ID: SSC) 中国语文",
      MATHS: "(ID: SSC) 数学",
      LIBERAL: "(ID: SSC) 通识教育/独立生活",
      PE: "(ID: SSC) 体育",
      ARTS: "(ID: SSC) 视觉艺术",
      IT: "(ID: SSC) 资讯及通讯科技",
      TECHNOLOGY: "(ID: SSC) 科技与生活",
      MUSIC: "(ID: SSC) 音乐",
      DESIGN: "(ID: SSC) 设计与应用科技",
      RELIGION: "(ID: SSC) 伦理与宗教",
      HEALTH: "(ID: SSC) 健康管理与社会关怀",
      APPLIED: "(ID: SSC) 应用学习调适课程",
    },
  },
};
